<template>
  <div class="insurance-content">
    <content-detail v-if="showContentDetail" :insurance-data="insuranceData" />
    <insurance-process v-if="showInsuranceProcess" />
    <insurance-claim v-if="showInsuranceClaim" />
  </div>
</template>

<script>
import insuranceApi from '../../../api/insurance-api';
import contentDetail from './contentDetail';
// import insuranceProcess from './insuranceProcess';

export default {
  data() {
    return {
      user_order_id: 0,
      insuranceData: {},
      showContentDetail: false,
      showInsuranceProcess: false,
      showInsuranceClaim: false,
    };
  },
  components: {
    contentDetail,
    'insurance-process': () => import('./insuranceProcess'),
    'insurance-claim': () => import('./insuranceClaim'),
  },
  methods: {
    showDetail() {
      this.caseCode = this.$router.currentRoute.query.caseCode;
      this.visa_product_id = Number(this.$router.currentRoute.query.visa_product_id);
      this.user_order_id = Number(this.$router.currentRoute.query.user_order_id) || 0;

      const loadingIns = this.$loading();
      insuranceApi.BusinessinsuranceDetails({ case_code: this.caseCode, visa_product_id: this.visa_product_id, user_order_id: this.user_order_id }).then((data) => {
        this.insuranceData = data;
        loadingIns.close();
      }).catch((e) => {
        loadingIns.close();
        if ('fundebug' in window) {
          window.fundebug.notifyError('获取保险详情失败', { url: window.location.href });
        }
      }).catch((e) => {
        if (e) console.log(e);
      });;
    },
  },
  created() {
    document.body.querySelector('#app').setAttribute('class', 'all-hide');

    if (this.$router.currentRoute.query.type === 'detail') {
      this.showContentDetail = true;
      this.showDetail();
    } else if (this.$router.currentRoute.query.type === 'process') {
      this.showInsuranceProcess = true;
    } else if (this.$router.currentRoute.query.type === 'claim') {
      this.showInsuranceClaim = true;
    }
  },
};
</script>

<style lang="less">
#app.all-hide {
  background-color: #f7f8fa;
  &::before {
    display: none;
  }
  & > div {
    display: none;
  }

  .visa-header {
    display: block;
  }

  .footer {
    display: block;
  }
  .insurance-content {
    display: block;
    margin-top: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/businessInsurance/insurancePage/insuranceView.vue